import useExperiments from '@alltrails/experiments/hooks/useExperiments';

const useIsMultiSelectOverlaysEnabled = () => useExperiments()['web-disco-rm-multi-select-map-overlays']?.value === 'on';

export default useIsMultiSelectOverlaysEnabled;
